import React, { useState } from "react";
import { useLocation } from '@reach/router';
import { ProcessLink } from "../../global/helpers"
import SubMenuItem from '../../components/sub_menu_item/sub_menu_item';

const ParentMenuItem = ({data, stagger}) => {
  const location = useLocation();
  const [subMenuClass, setSubMenuState] = useState('');  
  const link = ProcessLink(data.link); 

  if(typeof data.link.story != 'undefined'){
    let classes = "menu-item";
 
    if(data.sub_menu.length > 0){
      classes += ' menu-item-has-children'
    }

    const path = location.pathname;

    if(path === data.link.story.url){
      classes += ' current-menu-item'
    }

    let pathSplit = path.split('/');
    while(pathSplit.length > 1){
      pathSplit = pathSplit.splice(-1);
      if(pathSplit.join('/') === data.link.story.url){
        classes += ' current-menu-parent';
        break;
      }
    }


    //Sub Menu State
    const subMenuState = (e) => {
      if(data.sub_menu.length > 0){
        if(e._reactName === 'onMouseEnter'){
          setSubMenuState(' show--sub');
        }
        if(e._reactName === 'onMouseLeave'){
          setSubMenuState('');
        }
        if(e._reactName === 'onClick'){
          if(subMenuClass === ' show--sub'){
            setSubMenuState('');
          }else{
            setSubMenuState(' show--sub');
          }
        }
      }
    } 
    
    return(
      // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
      <li key={'parent_menu_' + stagger} className={classes + subMenuClass + " component"} onMouseEnter={subMenuState} onMouseLeave={subMenuState} animation-stagger={stagger}>
        <a href={link.url} target={link.target} rel={link.rel} title={link.title} className={link.cssClass}>{data.title}</a>
        {data.sub_menu.length > 0 && 
          <ul className="sub_menu">
            {data.sub_menu.map((footer_sub_menu, index) => (
              <SubMenuItem key={index} data={footer_sub_menu} />
            ))}
          </ul>
        }
      </li>
    )
  }
};
 
export default ParentMenuItem;